export default __webpack_public_path__ + "static/media/icon_calendar_10.d9e5f757.svg";